export default __webpack_public_path__ + "static/media/prodslide3.84155a61.jpg";